export default "__VITE_ASSET__BW_D08mD__"